export default __webpack_public_path__ + "static/media/chart-icon.8d1e0937.svg";